module.exports = __webpack_public_path__ + "static/media/27_tn.00937e75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/27_tn.jpg
// module id = 663
// module chunks = 0